import HyhButton from './Button/button.js';

export default HyhButton;